import React, { useMemo, createContext, useContext } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useExpertRatingDashboard } from "./ExpertRatingDashboardHook";
// Set the default state values for each context
export const ExpertRatingContext = /*#__PURE__*/createContext({});
export const ExpertRatingContextProvider = ({
  children
}) => {
  const ratingContext = useExpertRatingDashboard();
  const ratingDashboardContext = useMemo(() => ({
    ...ratingContext
  }), [ratingContext]);
  return /*#__PURE__*/React.createElement(ExpertRatingContext.Provider, {
    value: ratingDashboardContext
  }, children);
};
export const useExpertRatingContext = () => {
  return useContext(ExpertRatingContext);
};
ExpertRatingContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};